var _COUNTRY_INTERNATIONA, _COUNTRY_PHONE_REGEXS;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export var ERROR = 'incorrect_format';
var COUNTRIES = {
  ES: 'es',
  LV: 'lv',
  LT: 'lt'
};
var COUNTRY_INTERNATIONAL_CODES = (_COUNTRY_INTERNATIONA = {}, _defineProperty(_COUNTRY_INTERNATIONA, COUNTRIES.ES, '+34'), _defineProperty(_COUNTRY_INTERNATIONA, COUNTRIES.LV, '+371'), _defineProperty(_COUNTRY_INTERNATIONA, COUNTRIES.LT, '+370'), _COUNTRY_INTERNATIONA);
var COUNTRY_PHONE_REGEXS = (_COUNTRY_PHONE_REGEXS = {}, _defineProperty(_COUNTRY_PHONE_REGEXS, COUNTRIES.ES, /^(?!70)(6|7)\d{8}$/i), _defineProperty(_COUNTRY_PHONE_REGEXS, COUNTRIES.LV, /^(2)[\d]{7}$/), _defineProperty(_COUNTRY_PHONE_REGEXS, COUNTRIES.LT, /^8?6[\d]{7}$/), _COUNTRY_PHONE_REGEXS);
var SEPARATORS_REGEX = /(\s|-)/gi;
var INTERNATIONAL_CODE = /^\+/i;

var isInternationalCode = function isInternationalCode(phoneNumber) {
  return INTERNATIONAL_CODE.test(phoneNumber);
};

var phoneNumber = function phoneNumber(country) {
  if (!country) {
    throw Error('Country ID must be provided');
  }

  var countryInternationalCode = COUNTRY_INTERNATIONAL_CODES[country];
  var countryPhoneRegex = COUNTRY_PHONE_REGEXS[country];
  var internationalCodeRegex = new RegExp("^(\\".concat(countryInternationalCode, ")"), 'i');
  return function (phoneNumber) {
    if (!phoneNumber) {
      return ERROR;
    }

    var isInternationalCountryCode = internationalCodeRegex.test(phoneNumber);

    if (isInternationalCode(phoneNumber) && !isInternationalCountryCode) {
      return ERROR;
    }

    var strippedInternationalCode = phoneNumber.replace(internationalCodeRegex, '');
    var sanitizedPhoneNumber = strippedInternationalCode.replace(SEPARATORS_REGEX, '');
    var isValidCountryPhoneNumber = countryPhoneRegex.test(sanitizedPhoneNumber);

    if (!isValidCountryPhoneNumber) {
      return ERROR;
    }

    return null;
  };
};

phoneNumber.COUNTRIES = COUNTRIES;
export default phoneNumber;